import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private inMemoryToken: string | null = null;

  get(): string | null {
    return this.inMemoryToken;
  }

  set(token: string): void {
    this.inMemoryToken = token;
  }

  clear(): void {
    this.inMemoryToken = null;
  }
}


